export function getKey(key, userId) {
    return userId ? "officeHome-".concat(userId).concat(key) : key;
}
//# sourceMappingURL=getKey.js.map